import { render } from "./editTemplateForm.vue?vue&type=template&id=344c8cac&scoped=true"
import script from "./editTemplateForm.vue?vue&type=script&lang=js"
export * from "./editTemplateForm.vue?vue&type=script&lang=js"

import "./editTemplateForm.vue?vue&type=style&index=0&id=344c8cac&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344c8cac"]])

export default __exports__